window.ttx = window.ttx || {};
ttx.env = ttx.env || {};

ttx.env.getDomain = function () {
    return window.location.hostname || '';
};

ttx.env.getPort = function () {
    if (window.location.port) return window.location.port;
    return window.location.protocol === 'https:' ? '443' : '80';
};

ttx.env.getIp = function () {
    const host = window.location.hostname || '';
    const isIpv4 = /^\d{1,3}(\.\d{1,3}){3}$/.test(host);
    const isIpv6 = host.includes(':');
    if (isIpv4 || isIpv6) return host;

    try {
        return localStorage.getItem('ip') || '';
    } catch (_) {
        return '';
    }
};

ttx.env.getUserName = function () {
    try {
        return localStorage.getItem('user_name') || '';
    } catch (_) {
        return '';
    }
};

ttx.env.getUserId = function () {
    try {
        return localStorage.getItem('user_id') || '';
    } catch (_) {
        return '';
    }
};

ttx.env.getCurrentTime = function () {
    return new Date().toISOString();
};

ttx.env.getInfo = function () {
    return {
        domain: ttx.env.getDomain(),
        port: ttx.env.getPort(),
        ip: ttx.env.getIp(),
        userName: ttx.env.getUserName(),
        userId: ttx.env.getUserId(),
        currentTime: ttx.env.getCurrentTime()
    };
};

// ============================================================
// MDF cb.env API 补齐
// ============================================================

/**
 * 服务地址（需转发的请求地址）
 * 对应 MDF cb.env.getServiceUrl
 * 去 iframe 场景下与 getNodeServerUrl 一致
 * @returns {string}
 */
ttx.env.getServiceUrl = function () {
    // 优先复用 ttx.utils.getServiceUrl（tx.rest.js 中已使用）
    if (ttx.utils && typeof ttx.utils.getServiceUrl === 'function') {
        return ttx.utils.getServiceUrl() || '';
    }
    // 兜底：从 AppContext 取
    if (ttx.rest && ttx.rest.AppContext && ttx.rest.AppContext.serviceUrl) {
        return ttx.rest.AppContext.serviceUrl;
    }
    return '';
};

/**
 * Node 端服务地址
 * 对应 MDF cb.env.getNodeServerUrl
 * @param {boolean} [isHttp] 是否返回带 http 协议的地址
 * @returns {string}
 */
ttx.env.getNodeServerUrl = function (isHttp) {
    // 优先复用 ttx.utils.getNodeServerUrl
    if (ttx.utils && typeof ttx.utils.getNodeServerUrl === 'function') {
        var url = ttx.utils.getNodeServerUrl() || '';
        if (isHttp && url && url.indexOf('http') !== 0) {
            // 确保返回带协议的 http 地址
            url = window.location.protocol + '//' + url.replace(/^\/+/, '');
        }
        return url;
    }
    // 兜底：当前 origin
    return window.location.origin;
};

/**
 * 是否专属化环境（日常多数据库环境也返回 true）
 * 对应 MDF cb.env.isPremisesEnv
 * @returns {boolean}
 */
ttx.env.isPremisesEnv = function () {
    // 专属化标识优先从 ttx.context 取
    try {
        if (ttx.context && typeof ttx.context.isPremisesEnv === 'function') {
            return !!ttx.context.isPremisesEnv();
        }
        if (window.__INITIAL_STATE__ && window.__INITIAL_STATE__.__GLOBALZITION__) {
            var ctx = window.__INITIAL_STATE__.__GLOBALZITION__;
            // 专属化 / 多数据库标识
            return !!(ctx.isPremises || ctx.premises || (ctx.tenant && ctx.tenant.isPremises));
        }
    } catch (_) { }
    return false;
};

/**
 * 业务中台域名
 * 对应 MDF cb.env.getMainOriginUrl
 * @returns {string}
 */
ttx.env.getMainOriginUrl = function () {
    // 业务中台域名优先从 window.jDiwork 上下文取
    try {
        if (window.jDiwork && typeof window.jDiwork.diworkContext === 'function') {
            var ctx = window.jDiwork.diworkContext() || {};
            if (ctx.mainOriginUrl) return ctx.mainOriginUrl;
            if (ctx.mainOrigin) return ctx.mainOrigin;
        }
    } catch (_) { }
    // 兜底：当前 origin
    return window.location.origin;
};

/**
 * MDF 服务前缀（如 mdf-node）
 * 对应 MDF cb.env.getWindowBaseUrl
 * @returns {string}
 */
ttx.env.getWindowBaseUrl = function () {
    // MDF 服务前缀默认 mdf-node，可由 ttx.context 覆盖
    try {
        if (ttx.context && typeof ttx.context.getWindowBaseUrl === 'function') {
            return ttx.context.getWindowBaseUrl() || 'mdf-node';
        }
    } catch (_) { }
    return 'mdf-node';
};

/**
 * 是否本地协议访问（file://）
 * 对应 MDF cb.env.isFileProtocol
 * @returns {boolean}
 */
ttx.env.isFileProtocol = function () {
    // 优先复用 ttx.utils.isFileProtocol
    if (ttx.utils && typeof ttx.utils.isFileProtocol === 'function') {
        return !!ttx.utils.isFileProtocol();
    }
    return window.location.protocol === 'file:';
};
